import { CTAIconPosition, CTATag } from '../../atoms/CTA/CTA.constants';
import { HeadlineLevel } from '../../atoms/Headline/Headline';
import HeroBackground from './Hero.Background';
import {
  HeroContent,
  HeroContentSlot,
  HeroCopyStyled,
  HeroCTAStyled,
  HeroHeadlineStyled,
  HeroInner,
  HeroMedia,
  HeroSection,
  HeroSubHeadlineStyled,
} from './Hero.styles';

/**
 * @param {HeroProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Hero = ({
  headline,
  subHeadline,
  text,
  cta,
  mobileImage,
  style = 'NONE',
  ...rest
}) => {
  const background = 'video' in rest ? rest.video : rest.image;
  const parts = headline.split('*');
  const HeadlineFormatted = (
    <HeroHeadlineStyled level={HeadlineLevel.h1}>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <>
            <br />
            <strong key={index}>{part}</strong>
          </>
        ) : (
          part
        ),
      )}
    </HeroHeadlineStyled>
  );

  return (
    <HeroSection $fullWidth={true}>
      <HeroInner $fullWidth={true}>
        <HeroMedia data-id="hero-container">
          <HeroBackground
            data-id="hero-background"
            mobileImage={mobileImage}
            background={background}
            orientation={rest.orientation}
            heroEVP
            context="HERO"
          />
        </HeroMedia>
        <HeroContentSlot>
          <HeroContent
            $styling={style}
            data-id={`hero-content-container-${rest.orientation}`}
          >
            {HeadlineFormatted}
            {subHeadline && (
              <HeroSubHeadlineStyled level={HeadlineLevel.h2}>
                {subHeadline}
              </HeroSubHeadlineStyled>
            )}
            {text && <HeroCopyStyled>{text}</HeroCopyStyled>}
            {cta && (
              <HeroCTAStyled
                skin={cta.skin}
                title={cta.text}
                text={cta.text}
                type={CTATag.Link}
                icon="ARROW_ANIMATION"
                iconPos={CTAIconPosition.After}
                href={cta.href}
                target={cta.target}
                isBrand
              />
            )}
          </HeroContent>
        </HeroContentSlot>
      </HeroInner>
    </HeroSection>
  );
};

export default Hero;
